var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"xmessage"},[_c('div',{staticClass:"xmessage-body"},[_c('div',{staticClass:"content"},_vm._l((_vm.parsedHelp),function(riga,index){return _c('span',{key:index,domProps:{"innerHTML":_vm._s(riga)}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }